import moment from 'moment'

interface Props {
  isView: boolean
  documentStatus: string
  jobStatus: string
  updatedAt?: string
}

const DocumentStatus: React.FC<Props> = ({ documentStatus, jobStatus, updatedAt }) => {
  let documentClass = ''
  let documentText = ''
  let jobClass = ''
  let jobText = ''

  if (!documentStatus) {
    documentClass = 'badge badge-secondary'
    documentText = '-'
  } else if (documentStatus.toLowerCase() === 'draft') {
    documentClass = 'badge badge-primary'
    documentText = 'ร่าง'
  } else if (documentStatus.toLowerCase() === 'release') {
    documentClass = 'badge badge-success'
    documentText = 'เปิดใช้งาน'
  } else if (documentStatus.toLowerCase() === 'cancel') {
    documentClass = 'badge badge-danger'
    documentText = 'ยกเลิก'
  }

  if (!jobStatus) {
    jobClass = 'badge badge-secondary'
    jobText = '-'
  } else if (jobStatus.toLowerCase() === 'in-progress') {
    jobClass = 'badge badge-primary'
    jobText = 'กำลังสำรวจ'
  } else if (jobStatus.toLowerCase() === 'hold') {
    jobClass = 'badge badge-warning'
    jobText = 'อยู่ในช่วงพักการสำรวจ'
  } else if (jobStatus.toLowerCase() === 'cancel') {
    jobClass = 'badge badge-danger'
    jobText = 'ยกเลิกการสำรวจพื้นที่'
  } else if (jobStatus.toLowerCase() === 'completed') {
    jobClass = 'badge badge-success'
    jobText = 'สำรวจเสร็จสิ้น'
  }

  return (
    <div className='d-flex flex-column' style={{ rowGap: '12px' }}>
      <div>
        <span className='fw-bold'>วันที่แก้ไขเอกสารล่าสุด: </span>
        <span className={'badge badge-primary'}>
          {moment(updatedAt).isValid()
            ? moment(updatedAt).format('DD/MM/YYYY')
            : moment().format('DD/MM/YYYY')}
        </span>
      </div>

      <div>
        <span className='fw-bold'>สถานะเอกสาร: </span>
        <span className={documentClass}>{documentText}</span>
      </div>

      <div>
        <span className='fw-bold'>สถานะงาน: </span>
        <span className={jobClass}>{jobText}</span>
      </div>
    </div>
  )
}

export default DocumentStatus
